import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { setBetting } from 'virtual_congress/exhibition_actions'
import axios from 'axios';
import _ from 'lodash';
import useTranslation from "../../../../virtual_congress/effects/use_translation"

function Buttons(props) {
  return (
    <>
      {_.map(props.bet.fields, (field, fieldindex) => {
        return (
          <div className="form-check" key={"bet_" + props.bet + " " + field.id}>
            <input {...props.register("betting[bet_option_id]")} className="form-check-input" type="radio" value={field.id} id={"bet_" + props.bet.id + "bet_option_id_" + field.id} />
            <label className="form-check-label" htmlFor={"bet_" + props.bet.id + "bet_option_id_" + field.id} dangerouslySetInnerHTML={{ __html: field.title }}>

            </label>
          </div>
        )
      })
      }
      {props.errors && props.errors.bet_option_id &&
        <div className="invalid-feedback d-block">
          {props.errors.bet_option_id.message}
        </div>
      }
    </>

  )
}

export default function VotingForm({ bet, betting, options, thankYouText, videoRoom, ...props }) {
  const dispatch = useDispatch()
  const t = useTranslation(null, true)
  const finalThankYouText = videoRoom.voting_form_thank_you_text || t("video_room.voting_form.thank_you_text")?.props?.html || thankYouText || options?.thankYouText || "Vielen Dank für Ihre Teilnahme und viel Glück!"
  const { handleSubmit, formState: { errors }, setError, register } = useForm({ shouldUnregister: true })
  const tagOwner = useSelector((state) => state.tagOwner)
  const bettingsUrl = useSelector((state) => state.bettingsUrl).replace("@tag_owner_id@", tagOwner.id)
  const [sending, setSending] = useState(false)
  const [showThankYou, setShowThankYou] = useState(false)

  const validateForm = (data) => {
    if (sending) {
      return
    }
    setSending(true)
    data.bet_id = bet.id

    console.log("data", data)
    //replace("@video_room_id@", props.videoRoom.id).
    axios.put(bettingsUrl.replace("@id@", bet.id), data).then(response => {
      console.log("response", response.data)
      if (response.data.status == "OK") {
        console.log(response.data.questions)
        setShowThankYou(true)
        dispatch(setBetting(response.data.betting)) // Set here otherwise this will trigger thank you in voting.jsx so this message will be to short
        setTimeout(function () {
          setShowThankYou(false)
        }, 3000);
      } else {
        console.error(response.data.errors)

        {
          _.map(response.data.errors, (messages, field) => {
            {
              _.map(messages, (message, index) => {
                console.log("adding error", field, message)
                setError(field, { type: "not valid", message: message })
              })
            }
          })
        }


        setTimeout(function () {
          let elem = document.getElementsByClassName("Mui-error")
          if (elem && elem.length > 0)
            elem[0].parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 200)

      }
    },
      error => {
        alert(error)
        console.error(error)
      }
    ).then(function () { setSending(false) })
  }

  if (showThankYou || betting) {
    return <span dangerouslySetInnerHTML={{ __html: finalThankYouText }}>
    </span>;
  }

  return <form onSubmit={handleSubmit(validateForm)}>
    <div className="form-group row">
      <div className="col-8 col-md-10 pb-0">
        {bet.description &&
          <small className="text-muted">
            {bet.description}
          </small>
        }
        <Buttons bet={bet} errors={errors} register={register} />
      </div>
    </div>
    <div className="form-group mb-0">
      <button className="btn btn-sm btn-submit" type="submit">
        {sending ?
          <>
            <i className="fa fa-spinner fa-spin" />{" "}
            {videoRoom.voting_form_thank_you_text || t("video_room.voting_form.thank_you_text") || "Sende"}
          </>
          :
          <>
            <i className="fa fa-angle-right" />{" "}
            {videoRoom.voting_form_send_button_test || t("video_room.voting_form.send_button_text") || options?.sendButtonText || "Absenden"}
          </>
        }
      </button>
    </div>
  </form>
}


